import(/* webpackMode: "eager" */ "/app/apps/web/src/app/global-error.tsx");
